var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-checkbox',_vm._b({attrs:{"dense":"","color":"green darken-4","on-icon":"mdi-delete-restore","off-icon":"mdi-delete-outline"},on:{"change":_vm.onChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-checkbox',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }